export const ACCOUNT_TYPES = [
	{ value: "asset", label: "Asset" },
	{ value: "liability", label: "Liability" },
	{ value: "equity", label: "Equity" },
	{ value: "income", label: "Income" },
	{ value: "expense", label: "Expense" },
];

export const AMOUNT_KEYS = [
	{ value: "amount", label: "amount — principal (rent / payout / expense)" },
	{ value: "fee_paid", label: "fee_paid — fee / charge component" },
	{ value: "gross", label: "gross — amount + fee_paid" },
];

export const LINE_SIDES = [
	{ value: "debit", label: "Debit" },
	{ value: "credit", label: "Credit" },
];

export const STARTER_ACCOUNTS = [
	{ code: "1000", name: "Cash / MoMo clearing", account_type: "asset" },
	{ code: "2000", name: "Landlord payable", account_type: "liability" },
	{ code: "4000", name: "Rent income", account_type: "income" },
	{ code: "4100", name: "Service fee income", account_type: "income" },
	{ code: "5000", name: "Property expenses", account_type: "expense" },
];

export const TENANT_RENT_COLLECTED_EXAMPLE = [
	{ side: "debit", code: "1000", amount_key: "gross" },
	{ side: "credit", code: "4000", amount_key: "amount" },
	{ side: "credit", code: "4100", amount_key: "fee_paid" },
];
